import { render, staticRenderFns } from "./PonitAdd.vue?vue&type=template&id=5d0edcba&scoped=true&"
import script from "./PonitAdd.vue?vue&type=script&lang=js&"
export * from "./PonitAdd.vue?vue&type=script&lang=js&"
import style0 from "./PonitAdd.vue?vue&type=style&index=0&id=5d0edcba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0edcba",
  null
  
)

export default component.exports